var _path, _path2, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmcCpmPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 8c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6zm-2-0.398c0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602-4.198 0-8 3.403-8 7.602z",
    fill: "#2c2c2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 2c-3.314 0-6 2.686-6 6 0 3.314 2.686 6 6 6 3.314 0 6-2.686 6-6 0-3.314-2.686-6-6-6z",
    fill: "{color}",
    strokeWidth: 0.23409
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1.0297 .97114)",
    x: 11.842512,
    y: 10.039745,
    fill: "#000000",
    fontFamily: "'circles and sticks'",
    fontSize: "5.3952px",
    letterSpacing: "0px",
    strokeWidth: 1.0116,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 11.842512,
    y: 10.039745,
    fontSize: "5.3952px",
    strokeWidth: 1.0116,
    "text-align": "center",
    textAnchor: "middle"
  }, "\n\t\t\t\t\t{cpm}\n\t\t"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmcCpmPin);
export default __webpack_public_path__ + "static/media/GmcCpmPin.a38cfd91da9bc08fc3ef41a94764162d.svg";
export { ForwardRef as ReactComponent };